import { CalendarClock } from "lucide-react";

// Shown on Checkout for a seller with Dropit connected — Instant Order (the
// default) or Prebooking. Prebooking uses the ready-made Today/Tomorrow
// slots the server sends (IST, 30-min steps, first one at least 60 min
// away; see buildScheduleSlots on the server), re-validated when the order
// is placed.
export default function ScheduleDeliveryPicker({
  days,
  mode,
  onModeChange,
  deliveryClosed,
  selectedDay,
  selectedSlot,
  onSelectDay,
  onSelectSlot,
}) {
  const availableDays = (days || []).filter((d) => d.slots?.length > 0);
  if (availableDays.length === 0) return null;
  const activeDay = availableDays.find((d) => d.key === selectedDay) || availableDays[0];
  const modes = [
    { key: "instant", label: "Instant Order" },
    { key: "prebook", label: "Prebooking" },
  ];

  return (
    <div className="w-full bg-white rounded-2xl border border-slate-200/80 overflow-hidden shadow-2xs">
      <div className="px-4 py-3 border-b border-dashed border-slate-200 flex items-center gap-2 text-xs font-black text-slate-800 uppercase tracking-wide">
        <CalendarClock className="w-4 h-4 text-[#54AD56]" />
        <span>Schedule Delivery</span>
      </div>
      <div className="p-4 space-y-3">
        <div className="flex gap-2">
          {modes.map((m) => (
            <button
              key={m.key}
              type="button"
              onClick={() => onModeChange(m.key)}
              className={`flex-1 py-2 rounded-xl border text-xs sm:text-sm font-extrabold transition-colors cursor-pointer ${
                m.key === mode
                  ? "bg-[#54AD56] border-[#54AD56] text-white"
                  : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"
              }`}
            >
              {m.label}
            </button>
          ))}
        </div>

        {mode === "prebook" && (
          <>
            <p className="text-xs font-medium text-slate-500">
              {deliveryClosed
                ? "We're not delivering right now. Choose a delivery date and time."
                : "Choose a delivery date and time."}
            </p>
            <div className="flex gap-2">
              {availableDays.map((day) => (
                <button
                  key={day.key}
                  type="button"
                  onClick={() => onSelectDay(day.key)}
                  className={`flex-1 py-2 rounded-xl border text-xs sm:text-sm font-extrabold transition-colors cursor-pointer ${
                    day.key === activeDay.key
                      ? "bg-[#54AD56] border-[#54AD56] text-white"
                      : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"
                  }`}
                >
                  {day.label}
                </button>
              ))}
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
              {activeDay.slots.map((slot) => (
                <button
                  key={slot.value}
                  type="button"
                  onClick={() => onSelectSlot(slot.value)}
                  className={`py-2 rounded-xl border text-xs font-bold transition-colors cursor-pointer ${
                    slot.value === selectedSlot
                      ? "bg-[#54AD56]/10 border-[#54AD56] text-[#2E7D32]"
                      : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"
                  }`}
                >
                  {slot.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
